const MOBILE_QUERY = '(max-width: 767px)'

const Banner = ({ img, imgMobile, alt = '', link }) => {
  if (!img && !imgMobile) return null

  const picture = (
    <picture>
      {imgMobile && <source media={MOBILE_QUERY} srcSet={imgMobile} />}
      <img
        src={img || imgMobile}
        alt={alt}
        className="w-full h-auto object-cover"
        loading="lazy"
        decoding="async"
      />
    </picture>
  )

  return (
    <section className="my-8 lg:my-14">
      {link ? (
        <a href={link} className="block w-full">
          {picture}
        </a>
      ) : (
        picture
      )}
    </section>
  )
}

export default Banner
